import { CSSProperties, ChangeEvent, forwardRef } from 'react'

/**
 * Props do FileInput.
 */
type IFileInput = {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  className?: string
  style?: CSSProperties
  /**
   * Comma-separated list of accepted file types (e.g. `image/*`, `video/*`).
   */
  accept?: string
  /**
   * 'user' = front camera, 'environment' = back camera
   */
  capture?: 'user' | 'environment'
  isDisabled?: boolean
  multiple?: boolean
}

export const FileInput = forwardRef<HTMLInputElement, IFileInput>(
  (
    {
      onChange,
      className = '',
      style = {},
      accept = '*/*',
      capture,
      isDisabled = false,
      multiple = false,
    },
    ref
  ) => (
    <input
      ref={ref}
      disabled={isDisabled}
      type='file'
      className={`form-control form-control-solid ${className}`}
      accept={accept}
      onChange={onChange}
      style={{ flex: 1, ...style }}
      capture={capture}
      multiple={multiple}
    />
  )
)
